// Module
var code = "<md-button ng-show=\"backToTopCtrl.showBtnScroll\" ng-click=\"backToTopCtrl.scrollTop()\" class=\"md-fab\" aria-label=\"{{ ::'retour_en_haut_de_la_page' | translate }}\"> <md-icon md-svg-icon=\"keyboard_arrow_up\"></md-icon> </md-button> ";
// Exports
module.exports = code;